// BUCKET_CDN URL
const bucketImgCdnURL = "";
const bucketFileCdnURL = "";
import nookPayLogo from "@src/assets/Favicon.png";
const baseURL = import.meta.env.VITE_APP_PANEL_API_BASE_URL;

//Template config options
const themeConfig = {
  app: {
    name: "NookPay",
    logo: nookPayLogo
  },
  layout: {
    showOffset: 300
  },
  apiUrl: {
    base     : baseURL,
    ops      : `${baseURL}/ops`,
    brand    : `${baseURL}/brands`,
    affiliate: `${baseURL}/affiliates`
  },
  bucketImgCdnURL,
  bucketFileCdnURL,
  helpDeskURL: ""
};

export default themeConfig;
